import { Trans } from '@lingui/react'
import { arrayOf, bool, func, shape, string } from 'prop-types'
import { connectCurrentRefinements } from 'react-instantsearch-dom'

import { PRODUCT_FILTER_RESET } from 'shared/experiments/components/NewSerp/consts'
import { withSearchStateHandler } from 'shared/experiments/components/NewSerp/helpers'
import store from 'shared/store'
import IconBin from 'views/components/atoms/Icon/IconBin'
import ButtonWithIcons from 'views/components/molecules/ButtonWithIcons'

import './ClearRefinements.scss'

const ClearRefinements = ({ items, refine, filterId, disabled }) => (
  <ButtonWithIcons
    className="e-ClearRefinements"
    name={`clear-filter-${filterId}`}
    onClick={() =>
      withSearchStateHandler(() => {
        refine(items)
        store.dispatch({ type: PRODUCT_FILTER_RESET })
      })
    }
    style="buttonGhost"
    icon={<IconBin size="small" />}
    disabled={disabled}
    inline
  >
    <span className="u-font-weight--bold">
      <Trans id="searchResults.label.clearAllFilters" />
    </span>
  </ButtonWithIcons>
)

ClearRefinements.propTypes = {
  refine: func.isRequired,
  filterId: string.isRequired,
  items: arrayOf(shape({})),
  disabled: bool,
}

ClearRefinements.defaultProps = {
  items: [],
  disabled: false,
}

export default connectCurrentRefinements(ClearRefinements)
